import {FC, ReactNode} from 'react';

type TProps = {
    children: ReactNode;
    className?: string;
    padding?: boolean;
    center?: boolean;
}

const Panel: FC<TProps> = ({children, className, padding = true, center = false}) => {
    return (
        <div
            className={'cr-shadow cr-flex cr-rounded-block '
                + `${padding ? 'cr-p-lg ' : ''}${center ? 'cr-center ' : ''}${className ?? ''}`
        }>
            {children}
        </div>
    );
};

export default Panel;
